var _style, _circle, _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUserOffline(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:#D3D3D3;stroke-width:2;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.st1{fill:none;}\r\n\t.st2{fill:#DDDDDD;stroke:#D3D3D3;stroke-width:2;stroke-linecap:round;stroke-miterlimit:10;}\r\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 25,
    cy: 25,
    r: 24
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0,
    className: "st1",
    width: 50,
    height: 50
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M29.9,35.5c-0.1-1.6-0.1-2.7-0.1-4.2c0.7-0.4,2-2.8,2.3-4.9c0.6,0,1.5-0.6,1.7-2.8c0.1-1.2-0.4-1.9-0.8-2.1 c1-2.8,2.9-11.5-3.5-12.4c-0.7-1.2-2.4-1.8-4.6-1.8C16,7.5,15,14,16.9,21.5c-0.3,0.2-0.9,0.9-0.8,2.1c0.3,2.2,1.2,2.8,1.7,2.8 c0.2,2.1,1.6,4.5,2.3,4.9c0,1.5,0.1,2.6-0.1,4.2c-1.3,3.4-7.7,3.7-11.5,6.9c3.9,3.9,10.2,6.7,16.9,6.7s14.5-5.3,15.8-6.7 C37.7,39.2,31.2,38.9,29.9,35.5z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserOffline);
export default __webpack_public_path__ + "static/media/user_offline.e64d43e7426bb33c60d21d96cc69a3ea.svg";
export { ForwardRef as ReactComponent };